import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { I18nConsumer } from '@wegic/i18n-core';
import { IconClose } from '@wegic/icon';
import { PRICE_UI_I18N_NAMESPACE, priceUIi18nLoaders, StripeCheckout, StripeLoading } from '@wegic/price-ui';
import { SmartDrawer } from '@wegic/ui';
import '@wegic/ui/dist/components/SmartDrawer/index.css';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { bindStripeIframeReady } from './helper';
import styles from './index.module.less';
export default function StripeCheckoutDrawer(props) {
    const { visible, stripeOptions, isWaitingForPayment, onCancel, showCheckout, leftPanel, onIframeReady, onRetry, onRetryShow, waitingText } = props;
    const checkoutContainerRef = useRef(null);
    const hasReportedIframeReadyRef = useRef(false);
    const shouldShowCheckout = showCheckout ?? (!!stripeOptions && !isWaitingForPayment);
    const hasLeftPanel = !!leftPanel;
    useEffect(()=>{
        if (!shouldShowCheckout || isWaitingForPayment || !stripeOptions || !onIframeReady) {
            return;
        }
        const container = checkoutContainerRef.current;
        if (!container) {
            return;
        }
        return bindStripeIframeReady({
            container,
            onIframeReady,
            hasReportedRef: hasReportedIframeReadyRef
        });
    }, [
        isWaitingForPayment,
        onIframeReady,
        shouldShowCheckout,
        stripeOptions
    ]);
    return /*#__PURE__*/ _jsx(SmartDrawer, {
        open: visible,
        dismissible: false,
        className: styles['checkout-drawer'],
        children: /*#__PURE__*/ _jsxs(I18nConsumer, {
            loaders: priceUIi18nLoaders,
            namespace: PRICE_UI_I18N_NAMESPACE,
            children: [
                !isWaitingForPayment && /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: styles['close-btn'],
                    onClick: onCancel,
                    children: /*#__PURE__*/ _jsx(IconClose, {
                        fontSize: 20
                    })
                }),
                !shouldShowCheckout && !isWaitingForPayment && /*#__PURE__*/ _jsx("div", {
                    className: styles['loading-container'],
                    children: /*#__PURE__*/ _jsx(StripeLoading, {
                        className: styles['custom-stripe-loading'],
                        loadingText: intl.get('price.stripe.loading.text'),
                        loadingDesc: intl.get('price.stripe.loading.desc')
                    })
                }),
                shouldShowCheckout && !isWaitingForPayment && /*#__PURE__*/ _jsxs("div", {
                    className: classNames(styles['checkout-layout'], {
                        [styles['checkout-layout--single']]: !hasLeftPanel
                    }),
                    children: [
                        hasLeftPanel && /*#__PURE__*/ _jsx("div", {
                            className: styles['left-panel-wrapper'],
                            children: leftPanel
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            ref: checkoutContainerRef,
                            className: styles['checkout-container'],
                            children: stripeOptions && /*#__PURE__*/ _jsx(StripeCheckout, {
                                options: stripeOptions,
                                className: styles['custom-stripe-checkout'],
                                onRetry: onRetry,
                                onRetryShow: onRetryShow
                            })
                        })
                    ]
                }),
                isWaitingForPayment && /*#__PURE__*/ _jsxs("div", {
                    className: styles['websocket-loading-container'],
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.spinner
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles['websocket-loading-text'],
                            children: waitingText ?? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: intl.get('price.stripe.loading.text')
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: intl.get('price.stripe.loading.desc')
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
